function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgUwaf(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M80 4H16C9.383 4 4 9.383 4 16v64c0 6.617 5.383 12 12 12h64c6.617 0 12-5.383 12-12V16c0-6.617-5.383-12-12-12zm4 76c0 2.206-1.794 4-4 4H16c-2.206 0-4-1.794-4-4V32h72v48zm0-56H12v-8c0-2.206 1.794-4 4-4h64c2.206 0 4 1.794 4 4v8z"
  }), React.createElement("path", {
    d: "M37.114 53.874c.626 3.985 1.121 7.131 7.061 11.22 1.618 1.114 3.126 2.631 3.622 3.129l.879.879.8-.785a29.543 29.543 0 013.901-3.195c5.303-3.592 7.636-15.013 7.733-15.497l.189-.947L48.684 44 36 48.704l.276 1.001c.424 1.534.634 2.874.838 4.169z"
  }));
}

SvgUwaf.clsName = 'icon-www__uwaf';
SvgUwaf.remarkName = 'unknown';
export default SvgUwaf;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Uwaf.js
// module id = 2532
// module chunks = 17 18